import { render, staticRenderFns } from "./PraticaInfo.vue?vue&type=template&id=54e29ffb&scoped=true&"
import script from "./PraticaInfo.vue?vue&type=script&lang=js&"
export * from "./PraticaInfo.vue?vue&type=script&lang=js&"
import style0 from "./PraticaInfo.vue?vue&type=style&index=0&id=54e29ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e29ffb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e29ffb')) {
      api.createRecord('54e29ffb', component.options)
    } else {
      api.reload('54e29ffb', component.options)
    }
    module.hot.accept("./PraticaInfo.vue?vue&type=template&id=54e29ffb&scoped=true&", function () {
      api.rerender('54e29ffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaInfo.vue"
export default component.exports